import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import workspaceRepository from "../../respsitory/WorkspaceRepository";
import {Workspace} from "@/model/workspace";
export interface WorkspaceUpdateImportantRequest {
    important: boolean
}

const useUpdateWorkspaceImportant = (workspaceId: string) => {
    const queryClient = useQueryClient();
    return useMutation<Workspace, AxiosError, WorkspaceUpdateImportantRequest>({
        mutationKey: ["workspace", "update", "important"],
        mutationFn: async (body: WorkspaceUpdateImportantRequest) => {
            try {
                const { data } = await workspaceRepository.updateImportant(workspaceId, body);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries(["workspaces"], {exact: false});
        }
    })
};

export default useUpdateWorkspaceImportant;